import {
    GET_LOCATION_LISTING,
    GET_LOCATION_LISTING_SUCCESS,
    GET_LOCATION_LISTING_FAIL,
    GET_LOCATION_DETAILS,
    GET_LOCATION_DETAILS_SUCCESS,
    GET_LOCATION_DETAILS_FAIL,
    ADD_LOCATION,
    ADD_LOCATION_SUCCESS,
    ADD_LOCATION_FAIL,
    UPDATE_LOCATION,
    UPDATE_LOCATION_SUCCESS,
    UPDATE_LOCATION_FAIL,
    DELETE_LOCATION,
    DELETE_LOCATION_SUCCESS,
    DELETE_LOCATION_FAIL,
    EXPORT_LOCATION,
    EXPORT_LOCATION_SUCCESS,
    EXPORT_LOCATION_FAIL,
    RESET_LOCATION_STATE,
    RESET_LOCATION_ATTACHMENT_STATE,
} from "./actionTypes";

export const getLocationListing = (payload) => ({
    type: GET_LOCATION_LISTING,
    payload: payload
});

export const getLocationListingSuccess = categories => ({
    type: GET_LOCATION_LISTING_SUCCESS,
    payload: categories,
});

export const getLocationListingFail = error => ({
    type: GET_LOCATION_LISTING_FAIL,
    payload: error,
});

export const getLocationDetails = locationId => ({
    type: GET_LOCATION_DETAILS,
    payload: locationId,
});

export const getLocationDetailsSuccess = location => ({
    type: GET_LOCATION_DETAILS_SUCCESS,
    payload: location,
});

export const getLocationDetailsFail = error => ({
    type: GET_LOCATION_DETAILS_FAIL,
    payload: error,
});

export const createLocation = location => ({
    type: ADD_LOCATION,
    payload: location,
});

export const createLocationSuccess = location => ({
    type: ADD_LOCATION_SUCCESS,
    payload: location,
});

export const createLocationFail = error => ({
    type: ADD_LOCATION_FAIL,
    payload: error,
});

export const updateLocation = location => ({
    type: UPDATE_LOCATION,
    payload: location,
});

export const updateLocationSuccess = location => ({
    type: UPDATE_LOCATION_SUCCESS,
    payload: location,
});

export const updateLocationFail = error => ({
    type: UPDATE_LOCATION_FAIL,
    payload: error,
});

export const deleteLocation = ({ id, multiple }) => ({
    type: DELETE_LOCATION,
    payload: { id, multiple },
});

export const deleteLocationSuccess = locationId => ({
    type: DELETE_LOCATION_SUCCESS,
    payload: locationId,
});

export const deleteLocationFail = error => ({
    type: DELETE_LOCATION_FAIL,
    payload: error,
});

export const exportLocation = (payload) => ({
    type: EXPORT_LOCATION,
    payload: payload
});

export const exportLocationSuccess = data => ({
    type: EXPORT_LOCATION_SUCCESS,
    payload: data,
});

export const exportLocationFail = error => ({
    type: EXPORT_LOCATION_FAIL,
    payload: error,
});

//reset
export const resetLocationState = () => {
    return {
        type: RESET_LOCATION_STATE,
    }
}
//reset attachment
export const resetLocationAttachmentState = () => {
    return {
        type: RESET_LOCATION_ATTACHMENT_STATE,
    }
}

